import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

function normalizeLabel(o) {
  if (typeof o === 'string') return o;
  if (o && typeof o === 'object') return o.label || o.value || String(o);
  return String(o);
}

export default function CheckboxEditor({ value, column, onSave, onCancel }) {
  const currentValues = Array.isArray(value) ? value.map(v => String(v).trim()) : (value ? value.toString().split(',').map(v => v.trim()) : []);
  const [selected, setSelected] = useState(currentValues);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);

  const raw = column.options || [];
  const opts = Array.isArray(raw) ? raw.map(normalizeLabel) : [];

  useEffect(() => {
    if (anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.left });
    }
  }, []);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onCancel]);

  const toggleOption = (opt) => {
    setSelected(prev =>
      prev.includes(opt) ? prev.filter(v => v !== opt) : [...prev, opt]
    );
  };

  const dropdown = ReactDOM.createPortal(
    <div className="cm-checkbox-popover" style={{ top: pos.top, left: pos.left }}>
      <div className="cm-checkbox-popover__title">{column.name}</div>
      <div className="cm-checkbox-popover__list">
        {opts.map((opt, i) => (
          <label key={i} className="cm-checkbox-popover__option">
            <input
              type="checkbox"
              checked={selected.includes(opt)}
              onChange={() => toggleOption(opt)}
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>
      <div className="cm-checkbox-popover__actions">
        <button className="cm-btn cm-btn--sm cm-btn--primary" onClick={() => onSave(selected, [])}>
          <i className="fas fa-check" /> Guardar
        </button>
        <button className="cm-btn cm-btn--sm" onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </div>,
    document.body
  );

  return (
    <>
      <span ref={anchorRef} />
      {dropdown}
    </>
  );
}
